import React, { Component } from 'react'
import { PlaybookReportingLineGraph, PlaybookReportingStackedBars } from './Graphs'
import { Div } from '@driftt/tide-core'

const COLORS = {
  CLICKS: ['hsl(255, 62%, 65%)', 'hsla(255, 62%, 65%, 0.4)'],
  LOSS: ['hsl(11, 97%, 74%)', 'hsla(11, 97%, 74%, 0.4)'],
  ENROLLMENT: ['hsl(187, 62%, 64%)', 'hsla(187, 62%, 64%, 0.4)'],
  REVENUE: ['hsl(150, 83%, 44%)', 'hsla(150, 83%, 44%, 0.4)']
}

const LineChart = ({ data, colors }) => (
  <PlaybookReportingLineGraph
    data={data}
    colors={colors}
   />
)

const BarChart = ({data, colors}) => (
  <PlaybookReportingStackedBars
    data={data}
    />
)

const ClickChart = ({ data }) => {
  return (
    <LineChart data={data} colors={COLORS.CLICKS}/>
  )
}

const LossChart = ({ data }) => {
  return (
    <LineChart data={data} colors={COLORS.LOSS}/>
  )
}

const EnrollmentChart = ({ data }) => {
  return (
    <LineChart data={data} colors={COLORS.ENROLLMENT}/>
  )
}

const RevenueChart = ({ data }) => {
  return (
    <LineChart data={data} colors={COLORS.REVENUE} />
  )
}

const ConvoChart = ({ data }) => {
  return (
    <BarChart data={data} />
  )
}

const CHART_TYPE = {
  'TOTAL_ENROLLED': EnrollmentChart,
  'TOTAL_CLICKS': ClickChart,
  'TOTAL_LOSS': LossChart,
  'TOTAL_CONVERSATIONS': ConvoChart,
  'TOTAL_DOLLARS': RevenueChart
}

class GraphContainer extends Component {
  render() {
    const { activeTab, graphData } = this.props
    const Chart = CHART_TYPE[activeTab]


    const preppedGraphData = (activeTab !== 'TOTAL_CONVERSATIONS') ? [
      {
        id: 'Current',
        data: graphData.current
      },
      {
        id: 'Previous',
        data: graphData.previous
      }
    ] : graphData

    return (
      <Div className="reports-chart-render">
        {graphData &&
          <Chart data={preppedGraphData} />
        }
      </Div>
    )
  }
}

export default GraphContainer
